module.exports = __webpack_public_path__ + "img/1920.400.Industry.01.a2758bd9.png";